import React, { useRef, FormEvent, useState, useEffect } from "react";
import emailjs from "emailjs-com";
import styles from "./InputForm.module.css";
import Input from "../../Components/Input/Input";
import DropDown from "../../Components/DropDown.css/DropDown";
import TextArea from "../../Components/TextArea/TextArea";
import Button from "../../Components/Button/Button";
import { EncryptionService } from "../../services/EncryptionService";
import { useNavigate, redirect, Navigate } from "react-router-dom";

interface ContactFormData {
  source: string;
  company: string;
  firstname: string;
  lastname: string;
  phone: string;
  email: string;
}

const InputForm: React.FC = (): JSX.Element => {
  const reasons = [
    { value: "contracting", label: "Contracting" },
    { value: "investment", label: "Investment" },
    { value: "join_the_Team", label: "Join the Team" },
    { value: "services", label: "Consulting Services" },
    { value: "referal", label: "Make Referal" },
    { value: "other", label: "Other" },
  ];

  const [encryptionService] = useState(() => new EncryptionService());
  const [formData, setFormData] = useState<ContactFormData>({
    source: "",
    company: "",
    firstname: "",
    lastname: "",
    phone: "",
    email: "",
  });

  const fieldMap: Record<keyof ContactFormData, string> = {
    source: "r",
    company: "a",
    firstname: "b",
    lastname: "c",
    phone: "d",
    email: "e",
  };

  const encryptField = (value: string): string => {
    return encryptionService.encryptField(value);
  };

  useEffect(() => {
    encryptionService.loadPublicKey().catch((err) => {
      console.error("Failed to load public key:", err);
    });
  }, [encryptionService]);

  const form = useRef<HTMLFormElement | null>(null);

  const navigate = useNavigate();

  const sendEmail = async (e: FormEvent) => {
    e.preventDefault();

    const submitter = (e as unknown as SubmitEvent)
      .submitter as HTMLButtonElement;
    const buttonClicked = submitter?.id || submitter?.name;

    if (!form.current) return;

    const formElements = form.current
      .elements as typeof form.current.elements & {
      company: HTMLInputElement;
      firstname: HTMLInputElement;
      lastname: HTMLInputElement;
      phone: HTMLInputElement;
      email: HTMLInputElement;
      reason: HTMLSelectElement;
      text: HTMLTextAreaElement;
    };

    const updatedFormData = {
      source: "Contracts<32Gem$",
      company: formElements.company.value,
      firstname: formElements.firstname.value,
      lastname: formElements.lastname.value,
      phone: formElements.phone.value,
      email: formElements.email.value,
    };

    var r = "Contracts<32Gem$";
    var a = document.getElementById("companyTitle") as HTMLInputElement;
    var b = document.getElementById("firstname") as HTMLInputElement;
    var c = document.getElementById("lastname") as HTMLInputElement;
    var d = document.getElementById("phone") as HTMLInputElement;
    var ee = document.getElementById("email") as HTMLInputElement;
    //small change to merge dummy branch

    var url = `https://contractstest.icegems.com?r=Contracts<32Gem$&a=${a.value}&b=${b.value}&c=${c.value}&d=${d.value}&e=${ee.value}`;

    setFormData(updatedFormData);

    // Send email
    emailjs
      .sendForm(
        "service_bs3wryv",
        "template_9orzwzg",
        form.current,
        "zLI7pYxkBw-4JeI5P",
      )
      .then(
        () => {
          console.log("SUCCESS!");
        },
        (error: { text: any }) => {
          console.log("FAILED...", error.text);
        },
      );

    // Handle redirect if 'contracting'
    // if (formElements.reason.value === 'contracting') {
    //   if (!encryptionService.getPublicKey()) {
    //     alert("Public key not loaded");
    //     return;
    //   }

    //   const encryptedParams = (Object.keys(updatedFormData) as (keyof ContactFormData)[]).map(
    //     key => `${fieldMap[key]}=${encodeURIComponent(encryptField(updatedFormData[key]))}`
    //   );
    //   const finalUrl = `https://contracts.icegems.com/?${encryptedParams.join("&")}`;
    //   console.log(finalUrl);
    //   window.location.href = finalUrl;
    // } else {
    await new Promise((resolve) => setTimeout(resolve, 100));
    form.current.reset();
    navigate("../sent");

    //}
  };

  return (
    <div>
      <form
        id="form"
        ref={form}
        className={styles.formContainer}
        onSubmit={sendEmail}
      >
        <div className={styles.formContent}>
          <Input
            label="Company/Title"
            type="text"
            id="companyTitle"
            placeholder="Company Name"
            required={false}
            name="company"
          />

          {/* <div className={styles.nameInputs}> */}
          <Input
            label="First Name"
            type="text"
            id="firstname"
            placeholder="First Name"
            required={true}
            name="first_name"
          />
          <Input
            label="Last Name"
            type="text"
            id="lastname"
            placeholder="Last Name"
            required={true}
            name="last_name"
          />
          {/* </div> */}

          <Input
            label="Email"
            type="email"
            id="email"
            placeholder="Email"
            required={true}
            name="email"
          />
          <Input
            label="Phone"
            type="phone"
            id="phone"
            placeholder="(777)-777-7777"
            required={true}
            name="phone"
          />
          <DropDown
            label="Interest"
            id="reason"
            required
            options={reasons}
            name="reason"
          />
          <TextArea
            label="Message"
            id="message"
            placeholder="Message"
            required={true}
            rows={4}
            cols={50}
            name="text"
          />
        </div>
        <div className={styles.submittArea}>
          {/* <div className={styles.linkContainer}>
          <Button2 href='https://contracts.icegems.com/?r=l' name="contracts" text='Contracts' type="button"></Button2>
          <a href='https://qhicontracts.carescreen.net/QHILegalLanding?Role=IceGems' className={styles.hyperLink} type="submit"><b>Contracts</b></a>
        </div> */}
          <div className={styles.buttonFormat}>
            <Button name="send" text="Send" type="submit" />
          </div>
        </div>
      </form>
      <div className={styles.linkContainer}>
        {/* <Button2 href='https://contracts.icegems.com/?r=I' name="contracts" text='Contracts' type="button"></Button2> */}
        {/* <a href='https://contracts.icegems.com/?r=l' className={styles.hyperLink} ><b>Contracts</b></a> */}
      </div>
    </div>
  );
};

export default InputForm;
